export const rejectAndRevoke = (name, files)=>files.reduce((acc, file)=>{
        if (file.name === name) {
            URL.revokeObjectURL(file.blob);
            return acc;
        }
        return [
            ...acc,
            file
        ];
    }, []);
const isAlreadyAdded = (files, newFile)=>files.find((oldFile)=>oldFile.name === newFile.name && oldFile.size === newFile.size && oldFile.type === newFile.type);
const checkFileValidity = (append, files)=>(file)=>{
        if (file) {
            if (append && isAlreadyAdded(files, file)) {
                return null;
            }
            return {
                name: file.name,
                size: file.size,
                type: file.type,
                blob: URL.createObjectURL(file),
                file
            };
        }
        return null;
    };
export const addToFiles = (files, append, newFiles)=>{
    let result = newFiles.map(checkFileValidity(append, files));
    if (append) {
        result = [
            ...files,
            ...result
        ];
    }
    return result.filter((file)=>file);
};
